export default "__VITE_ASSET__BZ9pFSBe__"